module.exports = __webpack_public_path__ + "img/02_noff_open_L2.00986c1c.svg";